import { Component } from "react";
import { AlertTriangle } from "lucide-react";

// Isolates a report section so its failures never break sibling tabs.
export class ReportErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error) {
        console.error("Report section crashed:", error);
    }

    render() {
        if (this.state.error) {
            return (
                <div className="rounded-xl border border-rose-200 bg-rose-50/50 p-6 text-sm text-rose-800 flex items-start gap-3"
                     data-testid="report-section-error">
                    <AlertTriangle className="h-4 w-4 mt-0.5" />
                    <div>
                        <div className="font-medium">This report section failed to load.</div>
                        <div className="text-xs mt-1">Other report tabs are unaffected. Reload the page to retry.</div>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}
